import React from 'react';

export function LoadingScreen() {
  return (
    <div style={{
      position: 'absolute', inset: 0, display: 'flex',
      flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      background: '#06080d', color: '#cfdcec', fontFamily: 'monospace', gap: 16,
      zIndex: 100,
    }}>
      <div style={{
        width: 32, height: 32, border: '2px solid rgba(76,201,240,.2)',
        borderTopColor: '#4cc9f0', borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
      <div style={{ fontSize: 13, color: 'rgba(207,220,236,.55)' }}>Loading frame data...</div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
